import { Scope, Severity } from '@sentry/react';

import {
  configureSentry,
  configureSentryLogger,
  configureSentrySync,
} from './sentry';

export const TAG_FIREBASE_SENTRY: [string, string] = ['service', 'firebase'];

export const setTag = (scope: Scope) => {
  scope.setTag(...TAG_FIREBASE_SENTRY);
};

export const configureFirebaseSentry = (severity?: Severity) => {
  const { withSentry, scope } = configureSentry(severity);
  setTag(scope);
  return withSentry;
};

export const configureFirebaseSentrySync = (severity?: Severity) => {
  const { withSentry, scope } = configureSentrySync(severity);
  setTag(scope);
  return withSentry;
};

export const configureFirebaseSentryLogger = (
  prefix?: string,
  severity?: Severity,
) => {
  const { logger, scope } = configureSentryLogger(severity);
  setTag(scope);
  return (...data: any[]) => {
    if (typeof prefix === 'undefined') return logger(...data);
    return logger(prefix, ...data);
  };
};

export const withFirebaseErrorSentry = configureFirebaseSentry(Severity.Error);
export const withFirebaseWarningSentry = configureFirebaseSentry(
  Severity.Warning,
);
